import React, { useContext } from 'react';
import { CodeInputModal } from './CodeInputModal';
import { EINModalContainer } from './EINModalContainer';
import { NationalAccountContext } from '../../../../../contexts';
import { shared } from '../../../../../constants/NationalAccount';
import { Modal } from '../commons';
export var EnrollModals = function () {
    var validResponseState = useContext(NationalAccountContext).validResponseState;
    return (React.createElement(Modal, { title: shared.title }, (validResponseState === null || validResponseState === void 0 ? void 0 : validResponseState.enrollState) ? (React.createElement(CodeInputModal, null)) : (React.createElement(EINModalContainer, null))));
};
